// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2618977e","312":"a5012a6d","453":"8b913226","484":"ac42f8db","732":"3b9406c0"}[chunkId] + ".chunk.js";
};